import { createContext, useContext } from 'react';

type ProgressContextValue = {
  override: number | null;
  setOverride: (v: number | null) => void;
};

// The provider lives in ProgressProvider.tsx so this file stays free of
// components (React Fast Refresh).
export const ProgressContext = createContext<ProgressContextValue>({
  override: null,
  setOverride: () => {},
});

export function useProgress() {
  return useContext(ProgressContext);
}
